import { style } from '@vanilla-extract/css'

export const card = style({
  display: 'flex',
  flexFlow: 'column nowrap',
  alignItems: 'start',
  gap: '24px',
  borderRadius: '16px',
  padding: '16px',
  backgroundColor: 'white',
  boxShadow: '0px 8px 16px 0px #C5C5C50D',
  width: '100%',
})

// 画像と説明文のまとまり
export const flowerInfo = style({
  display: 'flex',
  flexFlow: 'column nowrap',
  alignItems: 'start',
  gap: '16px',
  width: '100%',
})

export const photo = style({
  width: '100%',
  height: '260px',
  borderRadius: '8px',
  objectFit: 'cover',
})

export const description = style({
  fontSize: '13px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  color: '#252525',
})

export const divider = style({
  width: '100%',
  height: '1px',
  backgroundColor: '#f2f1ef',
})

// お届け日・お届け先・合計金額のまとまり
export const fields = style({
  display: 'flex',
  flexFlow: 'column nowrap',
  alignItems: 'start',
  gap: '12px',
  width: '100%',
})

export const field = style({
  display: 'flex',
  flexFlow: 'column nowrap',
  alignItems: 'start',
  gap: '4px',
  width: '100%',
})

export const label = style({
  fontSize: '12px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  color: '#666666',
})

export const value = style({
  fontSize: '14px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
  color: '#212121',
})

export const invoiceLink = style({
  boxSizing: 'border-box',
  display: 'inline-block',
  fontWeight: '700',
  fontSize: '13px',
  lineHeight: '1.5',
  textAlign: 'center',
  textDecoration: 'none',
  color: '#252525',
  backgroundColor: 'white',
  border: '1.5px solid #252525',
  borderRadius: '32px',
  padding: '6.5px 14.5px',
})

export const text = style({
  fontSize: '13px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
})

export const sentinel = style({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  minHeight: '1px',
})
